import { ActionTypeKeys } from 'common/actions'
import { LS_RATE_TABLE_KEY } from 'embed/constants/testing'

export const testingMiddleware = () => (store) => (next) => (action) => {
  if (action.type === ActionTypeKeys.FETCH_RATE_TABLES_SUCCESS) {
    localStorage.setItem(LS_RATE_TABLE_KEY, JSON.stringify(action.data))
  }

  next(action)
}
